import { useTranslation } from 'react-i18next'
import { Popup } from 'react-vant'
import CustomButton from '@/components/CustomButton'

export interface AcceleratePopupProps {
  /** 是否显示弹窗 */
  visible: boolean
  /** 关闭弹窗回调 */
  onClose: () => void
}

const AcceleratePopup: React.FC<AcceleratePopupProps> = ({
  visible,
  onClose
}) => {
  const { t } = useTranslation()

  return (
    <Popup
      visible={visible}
      onClose={onClose}
      position="bottom"
      round
      closeIconPosition="top-right"
    >
      <div className="px-5 pt-10 pb-12 flex flex-col items-center">
        {/* 图标 */}
        <div className="w-20 h-20 rounded-full bg-[#EEF3FF] flex items-center justify-center mb-6">
          <img
            src="/images/card-v2/recharge-confirm.svg"
            alt="accelerate"
            className="w-10 h-10"
          />
        </div>

        {/* 文案 */}
        <div className="text-base text-[#4E5969] mb-10 text-center">
          {t('正在查询kyc审核状态请耐心等待')}
        </div>

        {/* 确定按钮 */}
        <div className="w-full">
          <CustomButton onClick={onClose}>
            {t('确定')}
          </CustomButton>
        </div>
      </div>
    </Popup>
  )
}

export default AcceleratePopup

